/* MRL mobile nav — native custom element, no dependencies */
(function(){
  'use strict';
  if (customElements.get('mrl-mobile-nav')) return;
  var FOCUSABLE = 'a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])';
  class MrlMobileNav extends HTMLElement {
    connectedCallback(){
      this.panel = this.querySelector('.mrlnav__panel');
      this.opener = null;
      this.onKey = this.onKey.bind(this);
      this.onDocClick = this.onDocClick.bind(this);
      this.addEventListener('click', this.onClick.bind(this));
      document.addEventListener('click', this.onDocClick, true);
      this.removeAttribute('hidden');
      this.setAttribute('data-open','false');
      // pre-open the section the visitor is currently in
      var active = this.querySelector('.mrlnav__item.is-active > .mrlnav__row');
      if (active) this.toggle(active, true, true);
    }
    disconnectedCallback(){ document.removeEventListener('click', this.onDocClick, true); }
    onDocClick(e){
      var btn = e.target.closest && e.target.closest('.js-drawer-open-left-link,[aria-controls="NavDrawer"]');
      if (!btn || this.contains(btn)) return;
      e.preventDefault(); e.stopImmediatePropagation();
      this.opener = btn;
      this.isOpen() ? this.close() : this.open();
    }
    onClick(e){
      var t = e.target;
      if (t.closest('[data-close]')) { e.preventDefault(); this.close(); return; }
      var row = t.closest('.mrlnav__row[aria-expanded]');
      if (row) { e.preventDefault(); this.toggle(row); return; }
      var link = t.closest('a[href]');
      if (link && !link.target) { this.close(true); }
    }
    toggle(row, force, silent){
      var open = typeof force === 'boolean' ? force : row.getAttribute('aria-expanded') !== 'true';
      this.querySelectorAll('.mrlnav__row[aria-expanded="true"]').forEach(function(r){ if (r !== row) r.setAttribute('aria-expanded','false'); });
      row.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && !silent) {
        var self = this;
        setTimeout(function(){
          var sc = self.querySelector('.mrlnav__scroll'), r = row.getBoundingClientRect(), s = sc.getBoundingClientRect();
          if (r.top < s.top + 8) sc.scrollBy({ top: r.top - s.top - 8, behavior: 'smooth' });
        }, 340);
      }
    }
    isOpen(){ return this.getAttribute('data-open') === 'true'; }
    open(){
      if (this.isOpen()) return;
      this.scrollY = window.scrollY;
      document.documentElement.classList.add('mrlnav-lock');
      this.setAttribute('data-open','true');
      this.setAttribute('aria-hidden','false');
      if (this.opener) this.opener.setAttribute('aria-expanded','true');
      document.addEventListener('keydown', this.onKey);
      var self = this;
      setTimeout(function(){ (self.querySelector('.mrlnav__close') || self.panel).focus({ preventScroll: true }); }, 60);
    }
    close(navigating){
      if (!this.isOpen()) return;
      this.setAttribute('data-open','false');
      this.setAttribute('aria-hidden','true');
      document.documentElement.classList.remove('mrlnav-lock');
      document.removeEventListener('keydown', this.onKey);
      if (this.opener) { this.opener.setAttribute('aria-expanded','false'); if (!navigating) this.opener.focus({ preventScroll: true }); }
    }
    onKey(e){
      if (e.key === 'Escape') { e.preventDefault(); this.close(); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(this.panel.querySelectorAll(FOCUSABLE), function(el){ return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length-1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }
  customElements.define('mrl-mobile-nav', MrlMobileNav);
})();
